import type { IActivePassesState } from '../nested-states/active-passes/states/active-passes.state';
import type { IExpiredPassesState } from '../nested-states/expired-passes/states/expired-passes.states';
import type { IFromLocationState } from '../nested-states/from-location/states/from-location.state';
import type { IFuturePassesState } from '../nested-states/future-passes/states/future-passes.states';
import type { IHallMonitorPassesState } from '../nested-states/hall-monitor-passes/states';
import type { IInvitationsState } from '../nested-states/invitations/invitations.state';
import type { IToLocationState } from '../nested-states/to-location/states/to-location.state';

export interface IPassLikeCollectionState {
	invitations?: IInvitationsState;
	expiredPasses?: IExpiredPassesState;
	futurePasses?: IFuturePassesState;
	activePasses?: IActivePassesState;
	toLocation?: IToLocationState;
	fromLocation?: IFromLocationState;
	hallMonitorPasses?: IHallMonitorPassesState;
}

export const passLikeCollectionInitialState: IPassLikeCollectionState = {};
